<template>
    <div class="cursor-pointer">
        <img :src="imageUrl" @click="show = true" class="row-span-full col-span-full shadow-lg">
        <Modal maxWidth="4xl" :show="show" @close="show = false" :transparent="true">
            <img :src="imageUrl" class="m-auto">
        </Modal>
    </div>
</template>

<script>
import Modal from './Modal'
export default {
    props: {
        imageUrl: {
            type: String
        },
    },
    components: {
        Modal
    },
    data() {
        return {
            show: false,
        }
    },
}
</script>
